import { useState } from "react";
import "./styles.css";

export default function App() {
  const [dob, setDob] = useState("");
  const [luckyNo, setLuckyNo] = useState(0);
  const [display, setDisplay] = useState("");

  function handleDobChange(e) {
    let inputDob = e.target.value;
    setDob(inputDob);
  }

  function handleLuckyChange(e) {
    let inputLuckyNo = e.target.value;
    setLuckyNo(inputLuckyNo);
  }

  function handleCheckClick() {
    let checkDob = dob.replaceAll("-", "");
    let checkLuckyNo = luckyNo;

    let dobSum = 0;
    for (let i = 0; i < checkDob.length; i++) {
      dobSum += parseInt(checkDob.charAt(i), 10);
    }

    if (dobSum % checkLuckyNo === 0) {
      setDisplay(`🎉Hmmm...${checkLuckyNo} is lucky for you`);
    } else {
      setDisplay(`😪Ooops...${checkLuckyNo} is not that lucky!`);
    }
  }

  return (
    <div className="App">
      <header>
        We care about your privacy, we don't store the inputs anywhere
      </header>
      <h1>Is your birthday lucky?</h1>

      <div className="card">
        <label htmlFor="dob">Date of Birth</label>
        <br />
        <input id="dob" type="date" onChange={handleDobChange} />
        <br />

        <label htmlFor="lucky-no">Lucky Number</label>
        <br />
        <input
          id="lucky-no"
          type="number"
          placeholder="Enter a number"
          onChange={handleLuckyChange}
        />
        <br />

        <button onClick={handleCheckClick}>Check Number</button>
      </div>

      <p>{display}</p>
    </div>
  );
}
